import { Tabs } from "antd"
import BookingTab from "./BookingTab"
import EmailsTab from "./EmailsTab"
import MessagesTab from "./MessagesTab"
import TextsTab from "./TextsTab"
import styles from "./index.module.css"

import { useState, useEffect } from "react"
import { useParams, useLocation } from "react-router-dom"

const ClientDetailsTabs = () => {
  const { id } = useParams()
  const location = useLocation()
  const { activeTab } = location.state || {}
  const [activeKey, setActiveKey] = useState("1")

  useEffect(() => {
    if (activeTab) {
      if (activeTab === "email") {
        setActiveKey("2")
      } else if (activeTab === "text") {
        setActiveKey("4")
      }
    }
  }, [activeTab])

  const items = [
    {
      key: "1",
      label: "Bookings",
      children: <BookingTab active={activeKey === "1"} id={id} />
    },
    {
      key: "2",
      label: "Emails",
      children: <EmailsTab active={activeKey === "2"} id={id} />
    },
    {
      key: "3",
      label: "Messages",
      children: <MessagesTab active={activeKey === "3"} id={id} />
    },
    {
      key: "4",
      label: "Texts",
      children: <TextsTab active={activeKey === "4"} id={id} />
    }
  ]

  return <Tabs className={styles.clientDetailsTabs} defaultActiveKey="1" activeKey={activeKey} onChange={setActiveKey} items={items} />
}

export default ClientDetailsTabs
